module.exports = __webpack_public_path__ + "static/img/lunbuo1.aadca4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/lunbuo1.jpg
// module id = mza2
// module chunks = 46